/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 组织架构状态管理 Slice（从 reducers/organization.js 迁移）
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../app/store'

// 部门类型定义
interface Department {
  id: string
  name: string
  [key: string]: any
}

interface OrganizationState {
  curDepartment: Department | null
  organization: any | null
  parentDepartmentIDs: string[]
  pickerOrganization: any | null // 部门成员选择器使用权限中心的组织结构
  pickerOrgUserCount: number // 部门成员选择器，权限中心的组织结构下的可访问用户数
}

const initialState: OrganizationState = {
  curDepartment: null,
  organization: null,
  parentDepartmentIDs: [],
  pickerOrganization: null,
  pickerOrgUserCount: 0
}

const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    setOrganization: (state, action: PayloadAction<any>) => {
      state.organization = action.payload
    },
    setCurDepartment: (state, action: PayloadAction<Department | null>) => {
      state.curDepartment = action.payload
    },
    setParentDepartmentIDs: (state, action: PayloadAction<string[]>) => {
      state.parentDepartmentIDs = action.payload
    },
    setPickerOrganization: (state, action: PayloadAction<any>) => {
      state.pickerOrganization = action.payload
    },
    setPickerOrgUserCount: (state, action: PayloadAction<number>) => {
      state.pickerOrgUserCount = action.payload
    }
  }
})

export const {
  setOrganization,
  setCurDepartment,
  setParentDepartmentIDs,
  setPickerOrganization,
  setPickerOrgUserCount
} = organizationSlice.actions

// Selectors
export const selectOrganization = (state: RootState) =>
  state.organization.organization
export const selectCurDepartment = (state: RootState) =>
  state.organization.curDepartment
export const selectParentDepartmentIDs = (state: RootState) =>
  state.organization.parentDepartmentIDs
export const selectPickerOrganization = (state: RootState) =>
  state.organization.pickerOrganization
export const selectPickerOrgUserCount = (state: RootState) =>
  state.organization.pickerOrgUserCount

export default organizationSlice.reducer
